import React, { useState } from "react";
import { Alert, Snackbar, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";

import TopBar from "../../../components/TopBar";
import DocumentReportFilters from "../components/DocumentReportFilters";
import ReportTable from "../components/ReportTable";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { useGetDocumentReportsHandler } from "../dataHandlers/getReportsHandler";
import { useCreateReportsJobHandler } from "../dataHandlers/createReportJobHandler";
import { reportTypes } from "../../../constants/appConstants";
import {useActionDeniedSnackbar} from "../../../hooks/useActionDeniedSnackbar";


const DocumentReportPage = () => {
    useDocumentTitle("Document Reports");
    const { org } = useSelector((/** @type {any} */ state) => state.org);
    const user = useSelector((/** @type {any} */ state) => state.user?.user);
    const showActionDeniedSnackbar = useActionDeniedSnackbar();
    const userEmail = org?.user?.email || user?.email || "";

    const [state, setState] = useState({
        page: 0,
        size: 10,
        localSuccessSnackbarOpen: false,
    });

    const { page, size, localSuccessSnackbarOpen } = state;

    const { reports, totalReports, loading } = useGetDocumentReportsHandler({
        searchQuery: { page, size, type: reportTypes.DOCUMENT_REPORT },
    });


    const { onSubmit } = useCreateReportsJobHandler();

    const handleGenerateReport = (reportData) => {

        onSubmit(reportData);
        setState((prev) => ({ ...prev, localSuccessSnackbarOpen: true }));
    };

    return (
        <Stack direction="column" sx={{ mt: "-1rem" }} spacing={2}>
            <Stack spacing={0.5}>
                <TopBar title="Document Reports" />
                <Typography variant="body2" color="text.secondary">
                    Filter, generate and download tax-compliant e-invoicing reports
                </Typography>
            </Stack>
            <DocumentReportFilters
                loading={loading}
                onGenerate={handleGenerateReport}
            />
            <ReportTable
                reports={reports}
                loading={loading}
                totalReports={totalReports}
                onPageChange={(newPage) =>
                    setState((prev) => ({ ...prev, page: newPage }))
                }
                onPageSizeChange={(newSize) =>
                    setState((prev) => ({ ...prev, size: newSize }))
                }
            />
            <Snackbar
                open={localSuccessSnackbarOpen}
                onClose={() =>
                    setState((prev) => ({ ...prev, localSuccessSnackbarOpen: false }))
                }
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    severity="success"
                    variant="filled"
                    onClose={() =>
                        setState((prev) => ({ ...prev, localSuccessSnackbarOpen: false }))
                    }
                >
                    {"Report initiated successfully. We will notify"}{" "}
                    <a
                        href={`mailto:${userEmail}`}
                        style={{
                            fontWeight: "bold",
                            color: "inherit",
                            textDecoration: "underline",
                        }}
                    >
                        {userEmail}
                    </a>{" "}
                    {"once it is ready."}
                </Alert>
            </Snackbar>
        </Stack>
    );
};

export default DocumentReportPage;